import React from 'react';

import Grid from "@material-ui/core/Grid";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import JoinedFiles from './joinedFiles/joinedFiles.component';
import SessionFiles from './sessionFiles/sessionFiles.component';
import DeletedFiles from './deletedFiles/deletedFiles.component';
import MissingFiles from './missingFiles/missingFiles.component';
import SessionActionButtonComponent from './sessionActionButton.component'

export const SessionDetail = ({session, currentFileId}) => {

  if(session){
  return (

    <Card>
    <CardHeader
      title={session.name}
      action= {
        <SessionActionButtonComponent  session={session} hideSession={()=>{}} />
      }/>
    <CardContent >

        <Grid md={12} item>
          <JoinedFiles session={session} currentFileId={currentFileId}></JoinedFiles>
          <SessionFiles session={session} currentFileId={currentFileId}></SessionFiles>
          <MissingFiles session={session}></MissingFiles>
          <DeletedFiles session={session}></DeletedFiles>
        </Grid>


    </CardContent>
  </Card>

  )
  }
  return ('')
}
